import { render } from "./TextBoxV2.vue?vue&type=template&id=40f515b8&scoped=true"
import script from "./TextBoxV2.vue?vue&type=script&lang=js"
export * from "./TextBoxV2.vue?vue&type=script&lang=js"

import "./TextBoxV2.vue?vue&type=style&index=0&id=40f515b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f515b8"],['__file',"src/containers/popup/components/TextBoxV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40f515b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40f515b8', __exports__)) {
    api.reload('40f515b8', __exports__)
  }
  
  module.hot.accept("./TextBoxV2.vue?vue&type=template&id=40f515b8&scoped=true", () => {
    api.rerender('40f515b8', render)
  })

}


export default __exports__